<div class="knowledgRisks-modal py-3 animated fadeIn fast px-md-5 px-0">
  <h5 class="text-center fs-24 fw-bold">INSTRUCTIVO PARA LA OBTENCIÓN DE LAS CONSTANCIAS ELECTRÓNICAS DE CONOCIMIENTO DE
    RIESGOS</h5>
  <div class="firstSection mt-5">
    <h5 class="fw-bold fs-16">A. ADVERTENCIAS QUE MONIFIC S.A. DE C.V. DA A CONOCER A LOS INVERSIONISTAS SOBRE LOS
      RIESGOS DE SU INVERSIÓN</h5>
    <p class="text-justify fs-14 mt-4 w-95 m-auto">
      <strong>MONIFIC S.A. DE C.V.</strong>
      hace del conocimiento en la Plataforma por este medio, la
      importancia de que sus Inversionistas lean toda la información divulgada por MONIFIC,
      respecto de cada una de las solicitudes de financiamiento de los Solicitantes o proyectos en los
      que estén considerando invertir.
      <br><br><br>
      Asimismo, <strong>MONIFIC S.A. DE C.V.</strong> advierte en su Plataforma a los Inversionistas que
      solo podrán invertir en las solicitudes de financiamiento publicadas, hasta que comprendan
      completamente los riesgos de su inversión, la forma y términos de las Operaciones que pueden
      concertar a través de la Plataforma y que dichas Operaciones son acordes a sus necesidades
      financieras.
      <br><br><br>
      <strong>MONIFIC S.A. DE C.V.</strong> da a conocer a los Inversionistas, previamente a la celebración
      del contrato que les permita realizar Operaciones en la Plataforma, advertencias respecto de los
      riesgos a los que estará sujeta su inversión, como las siguientes:
    </p>
    <ul class="fs-14 mt-4 w-80 my-4">
      <li>
        La imposibilidad de disponer los recursos invertidos en el momento en el que el Inversionista así lo requiera.
      </li>
      <li>
        La posibilidad de que no existan las condiciones para que, a través de la institución de
        financiamiento colectivo, se lleve a cabo la venta de los derechos o títulos que documenten las
        Operaciones.
      </li>
      <li>
        La posibilidad de perder la totalidad de los recursos que se hayan invertido a través de la
        institución de financiamiento colectivo, en caso de que el Solicitante no pague el financiamiento
        o este no se pueda recuperar.
      </li>
      <li>
        La posibilidad de invertir, a través de la institución de financiamiento colectivo, en
        sociedades o proyectos en etapa de formación que no tengan historial de operación probado,
        pudiendo perderse hasta el cien por ciento de la inversión. Además, la posibilidad de no recibir
        dividendos, ingresos, utilidades o regalías, y que, como resultado de la participación de más
        Inversionistas en la sociedad o proyecto de que se trate, los derechos corporativos puedan
        verse disminuidos.
      </li>
      <li>
        La posibilidad de que los estados financieros de las sociedades o proyectos en los que se
        invierta, no estén dictaminados por un auditor externo independiente, por lo que la información
        financiera podría no reflejar razonablemente la situación financiera de la sociedad o proyecto
        de que se trate.
      </li>
      <li>
        La posibilidad de recibir información inicial y subsecuente limitada en comparación a lo
        observado en el mercado de valores por lo que, eventualmente, el Inversionista podría no
        contar con suficiente información para tomar decisiones de inversión.
      </li>
      <li>
        La prohibición establecida para las instituciones de financiamiento colectivo de
        conformidad con lo previsto en el artículo 20 de la Ley y la imposibilidad para estas a que se
        refiere el artículo 11, tercer párrafo de dicho ordenamiento.
      </li>
    </ul>
    <p class="text-justify fs-14 mt-4 w-95 m-auto">
      En cumplimiento a lo ordenado por la autoridad correspondiente <strong>MONIFIC S.A. DE C.V.</strong>
      añade las advertencias acerca de cualquier otro riesgo de inversión que identifiquen y que
      no esté contemplado en las fracciones anteriores, así como mostrar cada advertencia con el
      tamaño de fuente empleado preponderantemente en la Plataforma que utilicen; las cuales
      pueden ser consultadas directamente por el inversionista con atención a clientes.
    </p>
  </div>
  <div class="twoSection mt-5">
    <h5 class="fw-bold fs-16">B. FORMULARIO PARA LA OBTENCIÓN DE LA CONSTANCIA ELECTRÓNICA DE CONOCIMIENTO DE RIESGOS
    </h5>
    <p class="text-justify fs-14 mt-4 w-95 m-auto">
      Una vez que los Inversionistas confirmen que han leído las advertencias contenidas en el
      apartado A. anterior, las instituciones de financiamiento colectivo deberán recabar, en un
      formulario que la propia institución proporcione, las respuestas sobre el conocimiento de los
      riesgos a que dichos Inversionistas se exponen por su inversión.
      <br><br><br>
      El siguiente es un ejemplo del formulario a que se refiere el párrafo anterior, el cual deberá ser
      desplegado por las instituciones de financiamiento colectivo en su Plataforma.
    </p>

    <form [formGroup]="checkoutValidate" novalidate class="needs-validation">
      <div>
        <div class="line"></div>
        <h5 class="fw-bold">1. Información de riesgos </h5>
        <div class="d-flex justify-content-around mt-4">
          <label class="form-check-label w-70" for="firstCheckOut">
            <strong>Riesgo de pérdida:</strong><br>¿Comprende que estas inversiones son riesgosas y que puede perder
            todo el dinero invertido?
          </label>
          <input class="form-check-input mt-2" type="checkbox" formControlName="firstCheckOut" id="firstCheckOut">
        </div>
        <div class="d-flex justify-content-around mt-4">
          <label class="form-check-label w-70" for="secondCheckOut">
            <strong>Riesgo de liquidez:</strong><br>¿Comprende que es posible que no podrá deshacerse anticipadamente de
            su inversión?
          </label>
          <input class="form-check-input mt-3" type="checkbox" formControlName="secondCheckOut" id="secondCheckOut">
        </div>
        <div class="d-flex justify-content-around mt-4">
          <label class="form-check-label w-70" for="thirdCheckOut">
            <strong>Riesgo de información:</strong><br>¿Comprende que es posible que la información
            que la institución de financiamiento colectivo proporcione sobre la oferta y
            el desempeño sucesivo de los Solicitantes de financiamiento, sea limitada?
          </label>
          <input class="form-check-input mt-4" type="checkbox" formControlName="thirdCheckOut" id="thirdCheckOut">
        </div>
        <div class="d-flex justify-content-around mt-4">
          <label class="form-check-label w-70" for="fourthCheckOut">
            <strong>Riesgo de rendimiento:</strong><br>¿Comprende que es posible que no obtenga
            ingreso o rendimiento alguno, tales como dividendos o intereses, por estas
            inversiones?
          </label>
          <input class="form-check-input mt-3" type="checkbox" formControlName="fourthCheckOut" id="fourthCheckOut">
        </div>
      </div>
      <div>
        <div class="line"></div>
        <h5 class="fw-bold">2. Información de riesgos </h5>
        <div class="d-flex justify-content-around mt-4">
          <label class="form-check-label w-70" for="fifthCheckOut">
            <strong>Sin aprobación:</strong>
            <br>
            ¿Comprende que las ofertas de inversión publicadas no
            han sido revisadas o aprobadas en forma alguna por la Comisión Nacional
            Bancaria y de Valores u otra autoridad?
          </label>
          <input class="form-check-input mt-3" type="checkbox" formControlName="fifthCheckOut" id="fiveCheckOut">
        </div>
        <div class="d-flex justify-content-around mt-4">
          <label class="form-check-label w-70" for="sixthCheckOut">
            <strong>Sin asesoría:</strong><br>¿Comprende que no recibirá asesoría sobre si las inversiones son adecuadas
            para usted?
          </label>
          <input class="form-check-input mt-3" type="checkbox" formControlName="sixthCheckOut" id="sixthCheckOut">
        </div>
      </div>
      <div>
        <div class="line"></div>
        <h5 class="fw-bold">3. Acerca de la inversión </h5>
        <div class="d-flex justify-content-around mt-4">
          <label class="form-check-label w-70" for="seventhCheckOut">
            <strong>Riesgos de inversión:</strong>
            <br>
            ¿Ha leído este formulario y comprende los riesgos de llevar a cabo estas inversiones?
          </label>
          <input class="form-check-input mt-2" type="checkbox" formControlName="seventhCheckOut" id="seventhCheckOut">
        </div>
        <div class="d-flex justify-content-around mt-4">
          <label class="form-check-label w-70" for="eighthCheckOut">
            <strong>Información divulgada:</strong>
            <br>
            Antes de invertir, deberá leer cuidadosamente la
            información divulgada por cada uno de los Solicitantes de financiamiento en
            los que usted considere realizar la inversión. Si no ha leído o no comprende
            dicha información, usted no debería invertir.
            ¿Comprende que, además de los riesgos generales de la inversión, deberá
            leer y entender la información divulgada por los Solicitantes de
            financiamiento?
          </label>
          <input class="form-check-input mt-5" type="checkbox" formControlName="eighthCheckOut" id="eighthCheckOut">
        </div>
      </div>
      <div>
        <div class="line"></div>
        <h5 class="mb-3 fw-bold">4. Información del inversionista </h5>
        <div class="d-flex justify-content-around">
          <div class="border w-50 p-3">
            Nombre completo: <br>
            <strong>{{this.fullname || 'Inversionista'}}</strong>
          </div>
          <div class="border w-50 p-3">
            Fecha de aplicación del cuestionario:<br>
            <strong>{{ signature | date: 'dd/MM/yy' }}</strong>
          </div>
        </div>
        <div class="border p-3">
          <strong>Firma electrónica: </strong>
          <br>
          Al hacer clic en el botón de confirmación, reconozco que estoy firmando
          este formulario electrónicamente, produciendo los mismos efectos que las leyes otorgan a la
          firma autógrafa.
        </div>
        <div class="border p-3">
          <strong>Dudas, quejas o sugerencias, comunícate con: </strong>
          <br>
          Lunes a Jueves de 9:00 a 17:00 y Viernes de 9:00 a 15:00. <br>
          Tel.: (55) 44383883 <br>
          Correo: contacto&#64;monific.com <br>
        </div>
      </div>
    </form>

    <button class="mt-4 btn btn-save m-auto d-block" type="submit" mat-button [disabled]="checkoutValidate.invalid"
      (click)="accept()" *ngIf="!submitted; else btnSubmitted">
      Confirmo
    </button>
    <ng-template #btnSubmitted>
      <button class="mt-4 btn btn-save m-auto d-block" type="button" mat-button (click)="accept()">
        Cerrar
      </button>
    </ng-template>
    <p class="text-justify fs-14 mt-4 w-95 m-auto">
      Se hace del conocimiento lo siguiente: <br><br>
      “Las instituciones de financiamiento colectivo deberán elaborar las preguntas del formulario
      que al efecto diseñen de tal forma que estas no puedan ser contestadas en su totalidad en
      sentido negativo o positivo.
      Cuando de cualquiera de las respuestas se desprenda que no se conocen los riesgos, las
      instituciones de financiamiento colectivo deberán interrumpir automáticamente el proceso de
      contratación y re-direccionar al Inversionista a la pantalla donde se describen las advertencias
      de los riesgos generales de invertir en los Solicitantes o proyectos que la institución de
      financiamiento colectivo de que se trate publique a través de su Plataforma.
      Al remitir las respuestas con su firma electrónica avanzada o cualquier otra forma de
      autenticación de conformidad con lo previsto en el artículo 56, primer párrafo de la Ley, los
      Inversionistas harán constar electrónicamente que conocen los riesgos asociados a su inversión
      en los Solicitantes o proyectos que la institución de financiamiento colectivo publique a través
      de su Plataforma.
      Las instituciones de financiamiento colectivo deberán conservar por un plazo mínimo de diez
      años el comprobante original de la constancia electrónica de riesgos, debidamente archivado,
      ya sea en formato impreso, o a través de medios electrónicos, ópticos o de cualquier otra
      tecnología.”.
    </p>
  </div>

</div>
